export class ExtensionManager {
    private viewer: Autodesk.Viewing.GuiViewer3D;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D) {
        this.viewer = viewer;
    }

    async load(id: string) {
        if (!this.viewer) throw new Error('Viewer not ready');
        const existing = this.viewer.getExtension(id);
        if (existing) return existing;

        return this.viewer.loadExtension(id);
    }

    get(id: string) {
        return this.viewer.getExtension(id);
    }

    getAllLoaded() {
        return this.viewer.getLoadedExtensions();
    }

    unload(id: string) {
        this.viewer.unloadExtension(id);
    }
}
